/** @jsx jsx */
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { css, jsx } from '@emotion/react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import currencyFormat from 'functions/currencyFormat'

import Button from 'components/Button'
import GlobalContext from 'agency/digital_renderer/utils/context'
import QuoteWrapper from 'agency/digital_renderer/components/QuoteWrapper'

import QuoteSection from './QuoteSection'
import styles from './styles.scss'

const downloadLink = (link) => {
  const { pathname } = window.location
  const shareLinkMatch = pathname.match(/\/share\/([\w-]+)/)

  if (shareLinkMatch){
    return `${link}?share_link_token=${shareLinkMatch[1]}`
  }

  return link
}

const CampaignQuote = (props) => {
  const {
    brand: { colour_primary, colour_highlight },
    campaignQuote,
    customCSS,
  } = props

  const defaultContext = useContext(GlobalContext)
  const { printMode } = defaultContext

  const customQuoteCSS = customCSS.quote

  return (
    <QuoteWrapper
      campaignQuote={campaignQuote}
      render={({ quoteSections }) => (
        <div
          className={styles.root}
          css={
            customQuoteCSS
              ? css`
                  ${customQuoteCSS}
                `
              : null
          }
        >
          {quoteSections.map(section => (
            <QuoteSection key={section.id} campaignQuoteSection={section} customCSS={customCSS} />
          ))}

          <div className={styles.footer} data-id="footer">
            {!printMode && campaignQuote.links && (
              <Button
                href={downloadLink(campaignQuote.links.pdf)}
                icon={<FontAwesomeIcon icon={faDownload} />}
                style={{
                  color: `#${colour_highlight}`,
                  backgroundColor: `#${colour_primary}`,
                  borderColor: `#${colour_primary}`,
                }}
                text="Download Quote"
              />
            )}

            <div className={styles.right} data-id="footer-right">
              <span className={styles.total} data-id="footer-total">
                {currencyFormat(campaignQuote.total)}
              </span>
            </div>
          </div>
        </div>
      )}
    />
  )
}

CampaignQuote.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignQuote: PropTypes.object.isRequired,
  customCSS: PropTypes.object,
}

export default CampaignQuote
